import supabase from "../../../supabaseClient.js";

export async function getChurchByName(name) {
  if (!name) {
    return { data: null, error: "Missing name" };
  }

  console.log("axios - getChurchByName called with:", name);

  const { data, error } = await supabase
    .from("church")
    .select("*")
    .eq("name", name)
    .limit(1)
    .maybeSingle();

  console.log("axios - Response data:", data);
  console.log("axios - Response error:", error);
  console.log("axios - userJoin in response:", data?.userJoin);

  if (error) {
    return { data: null, error: error.message };
  }
  return { data, error: null };
}

export async function getChurchByPersonCreate(personCreate) {
  if (!personCreate) {
    return { data: null, error: "Missing personCreate" };
  }

  console.log("axios - getChurchByPersonCreate called with:", personCreate);

  const { data, error } = await supabase
    .from("church")
    .select("*")
    .eq("personCreate", personCreate)
    .limit(1)
    .maybeSingle();

  console.log("axios - getChurchByPersonCreate Response data:", data);
  console.log("axios - getChurchByPersonCreate Response error:", error);
  console.log(
    "axios - getChurchByPersonCreate userJoin in response:",
    data?.userJoin
  );

  if (error) {
    return { data: null, error: error.message };
  }
  return { data, error: null };
}
